import React from 'react';

import Digit, { Value } from 'component/Layout/Icon/Number/_partials/Digit';

import { ReactComponent as IconThousandsSeparator } from 'media/svg/thousandsSeparator.svg';

export interface NumberProps {
    value: number;
    customClassList?: {
        Separator?: string;
    };
}

const Number = ({ value, customClassList }: NumberProps) => {
    return (
        <>
            {Array.from(String(value)).map((val, index) => {
                if (value > 999 && value < 10000 && index === 1) {
                    return (
                        <span key={index}>
                            <span className={customClassList?.Separator}>
                                <IconThousandsSeparator />
                            </span>
                            <span>
                                <Digit value={val as Value} />
                            </span>
                        </span>
                    );
                }
                if (value > 9999 && index === 2) {
                    return (
                        <span key={index}>
                            <span className={customClassList?.Separator}>
                                <IconThousandsSeparator />
                            </span>
                            <span>
                                <Digit value={val as Value} />
                            </span>
                        </span>
                    );
                }

                return (
                    <span key={index}>
                        <Digit value={val as Value} />
                    </span>
                );
            })}
        </>
    );
};

export default Number;
